import React, { FC } from 'react';
import { RowWrapper } from 'src/pages-all/tutoring-institute/components/common';
import { Text } from 'components/text/Text';
import { EYE, SEARCH, STAR } from 'assets/icons/tutoring-institute';
import styled from 'styled-components';
import { translate, translationKeys } from 'logic/translations/translations.service';

const Title = styled.span`
  display: flex;
  align-items: center;
`;

type HeaderIconProps = {
  src: any;
};

const HeaderIcon: FC<HeaderIconProps> = ({ src }) => (
  <img height={16} width={16} src={src} alt={'header'} style={{ marginRight: 4 }} loading="lazy" />
);

export const ListHeader: FC = () => {
  return (
    <RowWrapper>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.offerName)}</Text>
      </Title>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.location)}</Text>
      </Title>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.street)}</Text>
      </Title>
      <Title>
        <HeaderIcon src={STAR} />
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.rating)}</Text>
      </Title>
      <Title>
        <HeaderIcon src={SEARCH} />
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.foundInSearch)}</Text>
      </Title>
      <Title>
        <HeaderIcon src={EYE} />
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.visitor)}</Text>
      </Title>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.status)}</Text>
      </Title>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.edit)}</Text>
      </Title>
      <Title>
        <Text>{translate(translationKeys.tutoringInstituteProfile.offersPage.offerTable.delete)}</Text>
      </Title>
    </RowWrapper>
  );
};
